export enum RiskTypes {
  Risk = 1,
  Issue = 2,
  Opportunity = 3,
}
